import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

const ValueAdd = () => {
  const theme = useTheme();

  const items = [
    {
      title: 'Validación de 90 años',
      text: 'Honramos la herencia de Vital Pharma con el respaldo de la comunidad médica venezolana: dermatólogos, cirujanos plásticos y especialistas en medicina estética validan la eficacia de Atache.',
    },
    {
      title: 'Socio en Comunicación',
      text: 'Ofrecemos una solución integral que abarca producción audiovisual, editorial y relaciones públicas bajo un mismo estándar de excelencia. TNO Media Lab garantiza coherencia y calidad del mensaje de la marca.',
    },
    {
      title: 'Impacto en el Target',
      text: 'Conectamos directamente con la mujer venezolana que prioriza su salud y estética a través de una plataforma que valora la verdad y la excelencia. Expedientes del Delito aporta credibilidad periodística única.',
    },
  ];

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 'medium' }}
          gutterBottom
          color="primary"
          align="center"
        >
          Ventajas
        </Typography>
        <Box
          component={Typography}
          fontWeight={700}
          variant="h4"
          gutterBottom
          align="center"
          color="primary"
        >
          ¿Por qué Atache debe elegir a TNO Network?
        </Box>
      </Box>
      <Grid container spacing={3}>
        {items.map((item, i) => (
          <Grid item xs={12} md={4} key={i}>
            <Box
              sx={{
                p: 2,
                height: '100%',
                borderRadius: 2,
                border: `1px solid ${theme.palette.divider}`,
                bgcolor: theme.palette.mode === 'dark' ? 'action.hover' : 'grey.50',
              }}
              data-aos="fade-up"
              data-aos-delay={i * 80}
            >
              <Typography variant="h6" gutterBottom fontWeight={700}>
                {item.title}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {item.text}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
      <Box sx={{ mt: 4, p: 2, borderRadius: 2, bgcolor: theme.palette.mode === 'dark' ? 'action.hover' : 'grey.50', border: `1px solid ${theme.palette.divider}` }}>
        <Typography variant="overline" color="primary" fontWeight={600} display="block" gutterBottom>
          Experiencia presencial
        </Typography>
        <Typography variant="h6" gutterBottom fontWeight={700}>
          Atache Beauty Experience
        </Typography>
        <Typography variant="body2" color="textSecondary">
          Eventos de inmersión en los estudios de TNO Network donde clientas VIP y líderes de opinión viven la experiencia Atache de la mano de Angélica Lugo.
        </Typography>
      </Box>
    </Box>
  );
};

export default ValueAdd;
